import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import logger from '../utils/logger';

export interface ConsoleModeState {
  /** コンソールモードが有効かどうか */
  isConsoleMode: boolean;
}

/**
 * コンソールモード検出フック
 *
 * URLパラメータを解析してコンソールモードの状態を返します。
 * コンソールモードはAIエージェント向けのシンプルなCUIを提供します。
 *
 * @example
 * ```
 * // コンソールモード
 * https://app.midas-app.org/project/abc123?mode=console
 * ```
 */
export function useConsoleMode(): ConsoleModeState {
  const [searchParams] = useSearchParams();

  const state = useMemo(() => {
    const modeParam = searchParams.get('mode');
    const isConsoleMode = modeParam === 'console';

    if (isConsoleMode) {
      logger.info('[useConsoleMode] Console mode detected');
    }

    return {
      isConsoleMode,
    };
  }, [searchParams]);

  return state;
}
